export default __webpack_public_path__ + "static/media/rudeigin.9d50b737.mp3";